import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'ds-page-header',
  templateUrl: 'ds-page-header.component.html',
  styleUrls: ['ds-page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DsPageHeaderComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() showBack = true;
  @Output() back = new EventEmitter<void>();

  onBack(): void {
    this.back.emit();
  }
}
